import React, { useId } from 'react'
import PropTypes from 'prop-types'

const QrCodeIcon = React.forwardRef(function QrCodeIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M8 0H0V8H8V0ZM6 6H2V2H6V6ZM16 0V8H24V0H16ZM22 6H18V2H22V6ZM0 24H8V16H0V24ZM2 18H6V22H2V18ZM20 22H18V24H20V22ZM22 20H20V22H22V20ZM14 22H12V24H14 15 16V20H14V22ZM24 16H22V20H24V16ZM8 10H6V12H8V10ZM12 16H10V22H12V16ZM2 10H0V12H2V10ZM18 10H16V12H18V10ZM10 12H8V14H10V12ZM24 10H20V12H24V10ZM6 12H2V14H6V12ZM14 4H12V6H14V4ZM14 10V8H12V10H10V12H14V11 10ZM14 2V0H10V1 2 4H12V2H14ZM12 6H10V8H12V6ZM20 18H16V20H20V18ZM24 22H22V24H24V22ZM18 14H16V12H14V14H12V16H14V18H16V16H18 22V14H20V12H18V14Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

QrCodeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

QrCodeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default QrCodeIcon
